import * as yup from "yup";

const getStatusValidationSchema = (existingStatuses = []) =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .min(2)
      .max(255)
      .required("Name is required")
      .test(
        "unique-name",
        "A status with this name already exists",
        function (value) {
          if (!value) return true;
          return !existingStatuses.some(
            (status) =>
              status.label &&
              status.label.trim().toLowerCase() === value.trim().toLowerCase(),
          );
        },
      ),
    color: yup.string().min(2).max(255).required("Color is required"),
  });

export default getStatusValidationSchema;
